export default {
  siteName: "PixelHaha",
  creation: "Image IA",
  faceSwap: "Morphing",
  product: "Produit",
  magicBrush: "Brosse Magique",
  discover: "Découvrir",
  profile: "Profil",
  pricing: "Tarifs",
  freeCredits: "Crédits gratuits",
  credits: "Crédits",
  getMoreCredits: "Plus de crédits",
  left: "Gauche",
  upgradeToPremium: "Passer à la version premium",
  go: "Aller!",
  accountInformation: "Information sur le compte",
  signOut: "Se déconnecter",
  getMore: "Avoir plus",
  contactSupport: "Contactez le support",
  history: "Historique",
  login: "Connexion",
  signup: "Inscription",
  aiFuture: "Fonctionnalité AI",
  photoFaceSwap: "Échange de visage de photo",
  photoMutipleFaceSwap: "Échange de visages avec plusieurs images",
  videoFaceSwap: "Créateur de vidéos d'échange de visages",
  videoMutipleFaceSwap: "Échange de visages vidéo multiples",
  multipleFaceSwap: "Échange de Visages Multiples",
  aIImageGenerator: "Générateur d'Images AI",
  support: "Support",
  language: "langue",
  // userPolicy: "Politique d'Utilisation",
  // privacyPolicy: "Politique de Confidentialité",
  userPolicy: "Conditions générales",
  privacyPolicy: "politique de confidentialité",
  refundPolicy: "Politique de remboursement",
  FLARKLaw: 'Exemption 18 U.S.C 2257',
  policies: "Politiques",
  intellectual: "Droits de propriété intellectuelle",
  about: "À propos de nous",

  blog: "Blog",
  helpAndFAQS: "Aide & FAQ",
  sitemap: "Plan du Site",
  bussiness: "Entreprise",
  affiliateProgram: "Programme d'Affiliation",
  api: "API",
  contactUs: "Nous Contacter",
  aiFaceFunTitle: "Échange de visage vidéo IA en ligne",
  aiFaceFunSubTitle:
    "Échangez instantanément des visages avec l'échange de visage vidéo PixelHaha. Remplacez les visages des photos et des vidéos par ceux de votre choix. Créez des mèmes amusants avec notre produit alimenté par l'IA.",
  startFaceButtonTitle: "Commencer l'Échange de Visage",
  details: "Détails  >",
  chooseFace: "Choisir visage",
  faceSwaps: "échanges de visages",
  tryAgain: "Essayer à nouveau",
  faceswapUploadArea: {
    tab1Desc1:
      "Téléchargez la photo originale dans laquelle échanger le visage.",
    tab1Desc2: "Faites glisser et déposez une photo ou choisissez une photo",
    tab2Desc1:
      "Téléchargez l’image originale dans laquelle échanger le visage.",
    tab2Desc2: "Glissez et déposez une image ou choisissez une image",
    tab3Desc1: "Téléchargez la vidéo originale pour l'échange de visage.",
    tab3Desc2: "Glissez et déposez la vidéo ou choisissez la vidéo",
    tab4Desc1:
      "Téléchargez la vidéo originale dans laquelle faire l'échange de visage.",
    tab4Desc2: "Glissez et déposez la vidéo ou choisissez la vidéo",
    tab1title:
      "3 étapes pour échanger un visage dans des photos ou des images en ligne",
    tab1step1: "1. Téléchargez votre photo de visage originale.",
    tab1step2:
      "2. Téléchargez une photo du visage cible de la personne qui remplacera le visage de la photo originale. Vous pouvez également choisir parmi les démos de photos fournies.",
    tab1step3:
      "3. Démarrez Photo échange de visages, puis prévisualisez et téléchargez les résultats HD.",
    tab2title:
      "3 étapes pour échanger plusieurs visages dans des images en ligne",
    tab2step1: "1. Téléchargez votre photo de visage originale.",
    tab2step2:
      "2. Téléchargez une photo du visage cible de la personne qui remplacera le visage dans la photo originale. Vous pouvez également choisir parmi les démos d’images fournies.",
    tab2step3:
      "3. Démarrez Face Swap Picture, puis prévisualisez et téléchargez les résultats HD.",
    tab3title: "3 étapes pour échanger le visage dans les vidéos en ligne",
    tab3step1: "1. Téléchargez votre vidéo de visage originale.",
    tab3step2:
      "2. Téléchargez le visage cible de la personne qui remplacera le visage de la vidéo originale. Vous pouvez également choisir parmi les démos fournies.",
    tab3step3:
      "3. Démarrez Video Face Swap, puis prévisualisez et téléchargez les résultats HD.",
    tab4title: "3 étapes pour échanger le visage dans les vidéos en ligne",
    tab4step1: "1. Téléchargez votre vidéo de visage originale.",
    tab4step2:
      "2. Téléchargez le visage cible de la personne qui remplacera le visage de la vidéo originale. Vous pouvez également choisir parmi les démos fournies.",
    tab4step3:
      "3. Démarrez Video Face Swap, puis prévisualisez et téléchargez les résultats HD.",
    chooseFiles: "Choisir des fichiers",
    photoLimit: "10 Mo maximum",
    videoLimit: "Max 500 M, 10 minutes",
    uploading: "Téléchargement <xx1>",
    faceAnalyzing: "Analyse du visage",
    queuingAbout: "File d'attente... À propos de <xx1>s",
    analyzingAbout: "Analyse... À propos de <xx1>s",
    somethingError: "Quelque chose c'est mal passé. Merci d'essayer plus tard.",
  },

  review: {
    title: "Ils nous adorent, vous aussi",
    subtitle:
      "Rejoignez l'équipe de plus de 10 000 partenaires à travers le monde. Les récompenses qu'ils reçoivent du site sont continues et stables.",
    data1: {
      title: "J'adore utiliser PixelHaha !",
      content:
        "J'adore utiliser PixelHaha ! C'est mon outil préféré pour ajouter une touche de fun à mes photos. Que ce soit pour échanger des visages avec des amis ou essayer différents looks de célébrités, les résultats sont toujours hilarants et divertissants.",
      name: "Cliff Quan",
      dateText: "2 mars 2024",
    },
    data2: {
      title: "En tant qu'amateur de maquillage",
      content:
        "En tant qu'amateur de maquillage, j'utilise PixelHaha pour essayer de nouveaux looks avant de les adopter dans la vraie vie. Échanger mon visage avec différents personnages m'aide à visualiser comment divers styles m'iront. C'est un outil amusant et pratique pour tous ceux qui aiment expérimenter avec le maquillage !",
      name: "Anli Brevo",
      dateText: "16 mai 2024",
    },
    data3: {
      title: "Il est facile d'utiliser l'échange de visage vidéo",
      content:
        "Il est facile d'utiliser la fonction d'échange de visage vidéo pour remplacer votre visage par celui de quelqu'un d'autre. Que vous vouliez mettre le visage d'une star de cinéma sur votre tête ou remplacer votre visage par celui d'un joueur de basketball, cet outil fait le travail parfaitement. Continuez ainsi !",
      name: "Ada Wu",
      dateText: "19 avril 2024",
    },
    data4: {
      title: "Cet outil incroyable détecte intelligemment",
      content:
        "Cet outil incroyable détecte intelligemment les visages dans les photos et les remplace sans couture par n'importe quel visage de votre choix. C'est comme avoir votre propre studio créatif personnel à portée de main ! Avec PixelHaha, échanger des visages dans n'importe quelle photo est un jeu d'enfant, ce qui me permet de libérer mon imagination sans aucun tracas.",
      name: "Mario Kuper",
      dateText: "24 janvier 2024",
    },
    data5: {
      title: "J'ai toujours trouvé l'édition de photos difficile",
      content:
        "J'ai toujours trouvé l'édition de photos difficile, mais PixelHaha rend cela facile ! J'adore expérimenter avec les différentes options d'échange de visage IA et voir les combinaisons hilarantes. C'est une façon fantastique d'ajouter de l'humour à mes photos et de faire rire mes amis.",
      name: "Chris Jin",
      dateText: "12 décembre 2023",
    },
    data6: {
      title: "L'échange de visage IA est idéal pour créer des mèmes drôles",
      content:
        "L'échange de visage IA est idéal pour créer des mèmes drôles, des portraits et des vidéos d'échange de visage. PixelHaha est parfait non seulement pour le divertissement mais aussi pour la création de contenu engageant. Il vous aide à attirer plus d'attention sur les réseaux sociaux.",
      name: "Kotláriková",
      dateText: "24 mars 2024",
    },
  },
  faq: {
    title: "Questions Fréquemment Posées",
    details: "Détails  >",
    data1: {
      question: "Qu'est-ce que PixelHaha ?",
      answer:
        "PixelHaha est une plateforme visuelle d'IA utilisant des technologies avancées pour échanger automatiquement des visages, retoucher, améliorer, coloriser, corriger et cartooniser des images sans avoir besoin d'outils complexes d'édition photo comme Photoshop. En utilisant des algorithmes IA de pointe, PixelHaha simplifie le traitement des photos, économisant du temps, de l'énergie et des coûts pour les utilisateurs individuels et les entreprises nécessitant une édition photo en masse.",
    },
    data2: {
      question: "Comment fonctionne un outil d'échange de visage IA ?",
      answer:
        "L'échange de visage IA repose sur des algorithmes sophistiqués d'intelligence artificielle pour analyser méticuleusement les images sources, reconnaître les traits du visage et les remplacer sans couture par un autre visage tout en maintenant l'éclairage, les angles et les expressions naturels. Cela donne des échanges de visage réalistes générés par l'IA.",
    },
    data3: {
      question: "Comment utiliser l'échange de visage vidéo ?",
      answer:
        "Tout d'abord, sélectionnez une image de face claire comme base. Ensuite, choisissez le visage avec lequel vous souhaitez échanger, que ce soit le vôtre ou celui d'une célébrité. Troisièmement, lancez le processus de remplacement, et le visage choisi sera placé sans couture sur l'image de base.",
    },
    data4: {
      question: "Puis-je remplacer mon visage par n'importe quelle image ?",
      answer:
        "Oui, absolument. PixelHaha vous permet de remplacer votre visage par n'importe quelle image sélectionnée gratuitement. Par exemple, vous pouvez placer un visage masculin sur un portrait féminin ou un visage vieilli sur la photo d'un bébé. Les possibilités sont infinies, vous permettant de devenir n'importe qui sans limitations.",
    },
    data5: {
      question: "Comment obtenir le meilleur résultat ?",
      answer:
        "Pour obtenir des résultats optimaux avec l'échange de visage, suivez ces conseils: sélectionnez une photo claire avec des traits du visage bien définis, évitez les images floues. Assurez-vous qu'il n'y a qu'un seul visage sur la photo et que le visage est directement face à la caméra sans obstruction par des objets comme les mains.",
    },
    data6: {
      question: "Puis-je échanger des visages en ligne gratuitement ?",
      answer:
        "Absolument ! Vous pouvez échanger des visages en ligne gratuitement en utilisant PixelHaha. Nous offrons des plans gratuits et premium pour répondre à vos besoins. En tant que nouvel utilisateur, vous recevrez trois crédits lors de l'inscription, vous donnant un accès complet à notre service d'échange de visage et à d'autres fonctionnalités telles que la découpe de visage et la création d'avatar.",
    },
  },
  choose: {
    delText: "Etes-vous sûr de supprimer ce visage ?",
    leftBtnText: "Continuer",
    rightBtnText: "Annuler",
    overFaces:
      "Les visages téléchargés ont atteint la limite. Veuillez supprimer les autres visages pour continuer.",
    faceAn: "Analyse du visage...",
    facesuccess: "Succès de l'analyse du visage",
    facefailed: "Échec de l'analyse du visage",
    feedback: "Merci pour vos commentaires!",
    batchsupport:
      "Lot pris en charge ! Vous pouvez effectuer un nouvel échange de visage quel que soit le résultat actuel.",
    batchsupportAIGirl:
      "Prise en charge par lots ! Vous pouvez créer une nouvelle image IA quel que soit le résultat actuel.",
    submitting: "Soumission",
    queuing: "File d'attente",
    creating: "Création",
    downloading: "Téléchargement",
    retryText: "Quelque chose c'est mal passé. Merci d'essayer plus tard.",
    retry: "Recommencez",
    emailTip:
      "Veuillez saisir un suffixe de nom de domaine valide (tel que .com, .net, etc.)",
    noaccount: "Pas encore de compte ?",
    enterPassWord: "Entrer le mot de passe",
    passWordErr: "Définir un mot de passe de 8 caractères minimum",
    loginPassWordErr: "Mot de passe doit être d'au moins 8 caractères",
    forgotpass: "Mot de passe oublié?",
    googlesign: "Vous connecter avec Google Sign-In ?",
    resetpassword: "réinitialiser le mot de passe",
    readyaccount: "Vous avez déjà un compte?",
    confirm: "Confirmer",
    resetpasswordsuccess: "Réinitialisez le mot de passe avec succès !",
    senderror: "Envoyer une erreur !",
    sendsuccess: "Envoyez Succès !",
    signupfree: "Inscription gratuite",
    signupsuccess: "Inscription Succès !",
    sendcode: "envoyer le Code",
    loginsuccess: "connexion réussie!",
    logingerror: "erreur de connexion!",
    aboutS: "À propos {leftTime}s",
    keepPatient: "Soyez patient!",
    needMoretime: "Besoin de plus de temps!",
    aimostDoneKeep: "Presque fini! Soyez patient!",
    usernamePlace: "user{'@'}example.com",
    emailCode: "Code de vérification",
  },
  feedbackDialog: {
    title: "Nous avons besoin de vos commentaires pour améliorer PixelHaha.",
    subTitle1: "Envie de vous améliorer ?",
    option1: "Analyse de visage inexacte sur les fichiers téléchargés",
    option2: "On dirait pas",
    option3: "Problèmes de détails du visage (déformés, yeux, bouche, etc.)",
    option4: "Temps lent",
    option5: "Résultat Netteté",
    txtOption1: "Contenu sensible ou dérangeant",
    txtOption2: "Violation des conditions de service",
    txtOption3: "Pertinence rapide",
    txtOption4: "Visage déformé",
    txtOption5: "Contenu des images",
    txtOption6: "Netteté de l'image",
    txtOption7: "Temps lent",
    subTitle2: "Vous voulez en dire plus ?",
    placeholder: "D'autres suggestions...",
    submit: "Soumettre",
  },
  infoDialog: {
    advancedFeatures: "Fonctionnalités avancées",
    advancedFeaturesText:
      "Veuillez payer pour nos plans visant à débloquer une fonctionnalité d'échange de visage réaliste en vidéo.",
    choosePlan: "Choisir un forfait",
    insufficientCredits: "Crédits insuffisants",
    insufficientCreditsText: "Votre solde créditeur :",
    getMoreCredits: "Obtenez plus de crédits",
    videoTooBig: "La vidéo est trop grande",
    videoTooLong: "La vidéo est trop longue",
    videoCannotExceed: "La vidéo ne peut pas dépasser",
    inFileSize: "en taille de fichier",
    selectAnotherFile: "Sélectionnez un autre fichier",
    photoTooBig: "La photo est trop grande",
    photoCannotExceed: "La photo ne peut pas dépasser",
    tenMin: "10 minutes",
    deleteFile: "Êtes-vous sûr de supprimer ce fichier ?",
    cancel: "Annuler",
    confirm: "Confirmer",
  },
  allRightsReserved: "Tous droits réservés.",
  aiGirlIntroductionDetails: "Présentation de l'image AI Détails",
  aiGirlHowToUse: "Comment utiliser l'image AI",
  discoverHot: "Découvrir les recherches les plus populaires",
  aiGirlFAQDetails: "FAQ sur l'image AI Détails",
  lookslikeUploadOpps: {
    title: "Oops!",
    subtitle:
      "Oops! Dépassez les limites de crédits gratuits !\nVeuillez souscrire à un forfait pour utiliser toutes les fonctionnalités de manière illimitée.",
    unlockLimit: "Limite de déverrouillage",
  },
  selectStyle: "Sélectionnez le style",
  purchasePopup: {
    title: "Avec succès !",
    consumerSuccess: "Vous avez gagné <xx1> crédits",
    subscribeSuccess: "Accès illimité ! Profitez de notre service !",
    ok: "D'ACCORD",
  },
  affiliatePopup: {
    title: "Tutoriel sur le programme d'affiliation",
    first: "D'abord",
    second: "Deuxième",
    linkHint: "Lien vers le programme d'affiliation :",
    copy: "Copie",
    ok: "D'ACCORD",
  },
  photoEnhanceDetails: "Améliorer les détails de la photo",
  videoEnhanceDetails: "Détails de l'amélioration de la vidéo",
  imageEnhancer: "Amélioration de photos par l'IA",
  videoEnhancer: "Amélioration vidéo par l'IA",
  socialShareTitle:
    "Waouh ! Cette image créée par le générateur d'images AI est géniale, n'est-ce pas ?",
  copySuccess: "Copie réussie !",
  email: "E-mail",
  copy: "Copie",
};
